import { UNKNOWN_INPUT_TYPE } from '@/common/constants';
import {
    UPDATE_CONDITION,
    CENTER_DEL_CONDITION,
    CENTER_DEL_KEYWORD,
    CENTER_DEL_INPUT_BOX,
    SET_TRANSLATED_PROPS,
    CENTER_DEL_SUGGESTION,
    REMOVE_KEYWORD_MUTATION,
    MAP_CHANGE_MUTATION
} from '@/components/search-result/_store/types';
import * as TYPES from './types';
import util from '@/common/util';
import { setRecentlyPropertyType, getOutFields } from '../_util';
function postUiConfig(uiConfig) {
    if (!util.isSSRServer && window.parent) {
        window.parent.postMessage(
            {
                action: 'update_ui_config',
                data: JSON.parse(JSON.stringify(uiConfig))
            },
            '*'
        );
    }
}

const common = {
    [TYPES.SET_OUT_SIDE_FIELDS](payload) {
        this.outsideFields = [...payload];
    },
    [TYPES.SET_HIDDEN_OUT_FIELDS](hiddenOutFields) {
        this.hiddenOutFields = [...hiddenOutFields]
    },
    [TYPES.RESET_MOBILE_CONDITION]({ isMobileSize, theme }) {
        let conditions = Object.assign({}, this.conditions);
        let outFields = getOutFields({ isMobileSize, theme });
        Object.keys(this.conditions).filter(key => {
            if (outFields.includes(key)) {
                return true;
            }
            delete conditions[key];
            return false;
        });
        this.conditions = conditions;
    },
    [TYPES.SET_SEARCH_CHARTS](payload) {
        this.searchCharts = [...payload];
    },
    [TYPES.SET_CUSTOMIZED_CITY](payload) {
        this.customizedCity = (payload || []).map(
            ({ name, keyName, key, type }) => {
                const label = name || keyName;
                const value = key;
                return {
                    label,
                    value,
                    type
                };
            }
        );
    },
    [TYPES.SET_LISTING_SOURCE](payload) {
        this.listingSource = payload;
    },
    [TYPES.SET_LISTING_IDS](payload) {
        this.listingIds = payload;
    },
    [TYPES.CURRENCY_PRICE_KEYS](arr) {
        this.currencyPriceKeys = arr;
    },
    [SET_TRANSLATED_PROPS](payload) {
        this.translatedProps[payload.name] = payload.status;
    },
    [TYPES.SET_LOCATION_PLACEHOLDER](payload) {
        this.locationPlaceholder = payload;
    },
    [TYPES.UPDATE_RAWCONF_OPTIONS]({ name, options }) {
        if (this.fetcherData?.rawConf) {
            for (let i = 0; i < this.fetcherData.rawConf.length; i++) {
                let cfg = this.fetcherData.rawConf[i];
                for (let j = 0; j < cfg.conditions.length; j++) {
                    let c = cfg.conditions[j];
                    if (c.name === name) {
                        c.options = options;
                        return;
                    }
                }
            }
        }
    },
    [TYPES.CLEAR_ALL_CONDITION]() {
        this[REMOVE_KEYWORD_MUTATION]();
        this[MAP_CHANGE_MUTATION]({
            mapPath: null,
            mapSearch: false,
            mapRadius: null
        });
    }
};
const actions = {
    ...common,
    [TYPES.SET_SEARCH_CONFIG](payload) {
        const { fetcherData, conditionSort } = payload;
        this.fetcherData = { ...fetcherData };
        this.conditionSort = [...conditionSort];
    },
    [TYPES.INITIAL_CONDITION](payload) {
        this.conditions = { ...payload };
    },
    [UPDATE_CONDITION](payload) {
        if (payload.kee === 'Property-Type') {
            setRecentlyPropertyType(payload.value);
        }
        const conditions = { ...this.conditions, [payload.kee]: payload };
        if (!conditions[payload.kee].value) {
            delete conditions[payload.kee];
        }
        this.conditions = conditions;
    },
    [TYPES.SEARCH_RESET_MUTATION](more = false) {
        if (!more) {
            this.keywords = [];
            this.conditions = {};
            this.mapCondition = Object.assign({}, this.mapCondition, {
                mapPath: null,
                mapRadius: null
            });
        } else {
            let conditions = Object.assign({}, this.conditions);
            Object.keys(conditions).forEach(key => {
                if (conditions[key].inMore || this.hiddenOutFields.includes(key)) {
                    delete conditions[key];
                }
            });
            this.conditions = conditions;
        }
    },
    [TYPES.SEARCH_QUERY_ON_URL](payload) {
        this.searchQueryOnUrl = { ...payload };
    },
    [TYPES.LOCATION_QUERY_ON_URL](payload) {
        this.locationQueryOnUrl = payload;
    },
    [TYPES.URL_PRESET_PARAMS](payload) {
        this.urlPresetParams = payload;
    },
    [TYPES.MAP_CONDITION_ON_URL](payload) {
        this.mapConditionOnUrl = { ...this.mapConditionOnUrl, ...payload };
    }
};

const centerActions = {
    ...common,
    [TYPES.CENTER_SET_SEARCH_CONFIG_MAP](payload) {
        const { fetcherData, conditionSort } = payload;
        this.fetcherData = { ...fetcherData };
        this.conditionSort = [...conditionSort];
    },
    [TYPES.SEARCH_RESET_MUTATION](payload = []) {
        Object.keys(this.conditions).forEach(name => {
            if (!payload.includes(name)) {
                delete this.conditions[name];
            }
        });
    },
    [TYPES.RESET_KEY_WORDS]() {
        this.keywords = [];
    },
    [TYPES.CENTER_SET_UI_CONFIG](payload) {
        this.uiConfig = { ...payload };
    },
    [TYPES.CENTER_COMPUTED_PRESET_FILTER](payload) {
        this.computedPresetFilter = payload;
    },
    [TYPES.CENTER_UPDATE_CONDITION](payload) {
        if (payload.name === 'propertytype') {
            setRecentlyPropertyType(payload.data.value);
        }
        this.conditions = {
            ...this.conditions,
            ...{ [payload.name]: payload.data }
        };
    },
    [TYPES.CENTER_RESET_CONDITION]() {
        this.conditions = {};
    },
    [TYPES.CENTER_UPDATE_UI_CONFIG_ITEM](payload) {
        const { name, data } = payload;
        const originConfig = this.uiConfig;
        let config = originConfig[name] || {};
        config = { ...config, ...{ [name]: data } };
        this.uiConfig = { ...originConfig, ...config };
        postUiConfig(this.uiConfig);
    },

    [CENTER_DEL_CONDITION](payload) {
        delete this.conditions[payload];
    },
    [CENTER_DEL_INPUT_BOX](payload) {
        const { name, delTag } = payload;
        const condition = this.conditions[name];
        const value = condition.value;
        if (/^,/.test(value) || /,$/.test(value)) {
            delete this.conditions[name];
        } else {
            const temp = value.split(',');
            temp[delTag] = '';
            this.conditions[name].value = temp.join(',');
        }
    },
    [CENTER_DEL_SUGGESTION](payload) {
        const { name, delTag } = payload;
        const condition = this.conditions[name];
        if (condition.value.length === 1) {
            delete this.conditions[name];
        } else {
            this.conditions[name].value.splice(delTag, 1);
        }
    },
    [CENTER_DEL_KEYWORD](payload) {
        const { name, delTag } = payload;
        const condition = this.conditions[name];
        if (condition.value.length === 1) {
            delete this.conditions[name];
        } else {
            this.conditions[name].value.splice(delTag, 1);
        }
    },
    [TYPES.CENTER_DEL_SELECT](payload) {
        delete this.conditions[payload];
    },
    [TYPES.CENTER_SET_SWITCH](payload) {
        const { checked, kee } = payload || {};
        if (checked) {
            this.conditions[kee] = {
                value: true,
                type: 'checkBox'
            };
        } else {
            delete this.conditions[kee];
        }
    },
    [TYPES.CENTER_URL_PRESET_PARAMS](payload) {
        this.urlPresetParams = payload;
    },
    [TYPES.CENTER_CONDITION_ON_URL](payload) {
        this.conditionOnUrl = { ...payload };
    },
    [TYPES.CENTER_COMMIT_CONDITION]() {
        const {
            computedPresetFilter,
            searchConfigMap
        } = this;
        if (util.isEmpty(searchConfigMap)) {
            return;
        }

        this[TYPES.CENTER_RESET_CONDITION]();

        Object.entries(computedPresetFilter).forEach(([name, value]) => {
            if (name in searchConfigMap) {
                const config = searchConfigMap[name];
                const { inputType } = config;
                if (inputType === 'suggestion') {
                    value = Object.keys(value).reduce((memo, type) => {
                        const items = value[type];
                        items.forEach(i => {
                            memo.push(`${type}:${i}`);
                        });
                        return memo;
                    }, []);
                }
                this[TYPES.CENTER_UPDATE_CONDITION]({
                    name,
                    data: {
                        value,
                        inputType
                    }
                });
            } else {
                this[TYPES.CENTER_UPDATE_CONDITION]({
                    name,
                    data: {
                        value,
                        inputType: UNKNOWN_INPUT_TYPE
                        // inMore: true
                    }
                });
            }
        });
    },
    [TYPES.CENTER_UPDATE_KEYWORD_CONDITION](payload) {
        const { name, data } = payload;
        const origin = this.conditions[name]?.value || [];
        const value = data.value;
        if (!origin.includes(value) && value !== '') {
            origin.push(value);
            this[TYPES.CENTER_UPDATE_CONDITION]({
                name,
                data: {
                    ...data,
                    value: origin
                }
            });
        }
    },
    [TYPES.CENTER_UPDATE_DEFAULT_CONDITION](payload) {
        const { name, data } = payload;
        const value = data.value;
        if (value === '') {
            this[CENTER_DEL_CONDITION](name);
        } else {
            this[TYPES.CENTER_UPDATE_CONDITION](payload);
        }
    },
    [TYPES.CENTER_UPDATE_ARRAY_CONDITION](payload) {
        const { name, data } = payload;
        const value = data.value;
        if (value.length === 0) {
            this[CENTER_DEL_CONDITION](name);
        } else {
            this[TYPES.CENTER_UPDATE_CONDITION](payload);
        }
    },
    [TYPES.CENTER_UPDATE_INPUT_BOX_CONDITION](payload) {
        const { name, data } = payload;
        const value = data.value;
        if (!value || value === ',') {
            this[CENTER_DEL_CONDITION](name);
        } else {
            this[TYPES.CENTER_UPDATE_CONDITION](payload);
        }
    }
};
export default searchCenter => (searchCenter ? centerActions : actions);
